import { Component, OnInit, OnDestroy } from '@angular/core';
import { RecipeObject } from 'src/app/interfaces/recipe.interface';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-recipe-list',
  templateUrl: './recipe-list.component.html',
  styleUrls: ['./recipe-list.component.scss']
})
export class RecipeListComponent implements OnInit, OnDestroy {

  recipeList: RecipeObject[] = [];
  subs: Subscription;

  constructor(public dataService: DataService) { }

  ngOnInit() {
    this.subs = this.dataService.recipeList$.subscribe(data => this.recipeList = data);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }


}